export type {
  CollectionEditorProps,
  CollectionEditorRenderItemProps,
} from '../../types/collection-editor';
export { CollectionEditor } from './adapters/inbound/CollectionEditor';
